import { useEffect } from 'react';

/**
 * Sets document.title and per-page meta description / Open Graph tags.
 * The static fallbacks in index.html cover the initial load; this overwrites
 * them dynamically on every navigation.
 *
 * Usage:
 *   usePageMeta({ title: 'Book Flights Faster | AirFlyNow — Smart Flight Tagging', description: '...' });
 */
export default function usePageMeta({ title, description }) {
  useEffect(() => {
    const setMeta = (attr, attrVal, content) => {
      let el = document.querySelector(`meta[${attr}="${attrVal}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, attrVal);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    if (title) {
      document.title = title;
      setMeta('property', 'og:title', title);
      setMeta('name', 'twitter:title', title);
    }

    if (description) {
      setMeta('name', 'description', description);
      setMeta('property', 'og:description', description);
      setMeta('name', 'twitter:description', description);
    }
  }, [title, description]);
}
